export default {
  "loading": "Carregando",
  "feedbackMessages": {
    "badNps": {
      "message1": "Obrigado pela sua opinião",
      "message2": "Vamos melhorar!"
    },
    "regularNps": {
      "message1": "Obrigado pela sua opinião",
      "message2": "Vamos continuar melhorando!"
    },
    "goodNps": {
      "message1": "Obrigado por sua opinião",
      "message2": "É muito importante para nós!"
    },
    "error": {
      "message1": "Ocorreu um erro",
      "message2": "Tente atualizar para tentar novamente"
    }
  },
  "disclaimer": "Esta pesquisa não é anônima, o que nos permitirá contatá-lo para receber seus comentários e sugestões."
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/portuguese/survey/index.js